"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconVehicleCharging = function IconVehicleCharging(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "m23.724 5.292 1.412 1.416-1.86 1.853 1.34 1.34 1.817-1.818 1.414 1.414-1.817 1.818 1.405 1.405-2.524 2.524a5 5 0 0 1-5.957.837 2.64 2.64 0 0 0 .34 2.918l.143.154-.603.603.603-.603 4.14 4.14-.01.01a3.91 3.91 0 0 1 0 5.533 3.91 3.91 0 0 1-5.374.153l-.16-.152L14 24.804V43h-2V16a3 3 0 0 0-2.824-2.995L9 13H5v-2h4a5 5 0 0 1 4.995 4.783L14 16v5.976l5.447 5.447-.643.643.644-.642a1.91 1.91 0 0 0 2.706-.002 1.91 1.91 0 0 0 .113-2.58l-.113-.124.67-.672-.661.661-4.14-4.14a4.64 4.64 0 0 1-.611-5.81 5 5 0 0 1 .428-6.583l2.524-2.525 1.498 1.498zm-3.361 3.185 4.243 4.243-1.11 1.11a3 3 0 0 1-4.118.117l-.144-.137c-1.15-1.151-1.15-3.05.02-4.222zM3.46 27.84l3.61-7.21V26h1.8l-3.61 7.25v-5.41zm30.523-1.01-8.063-7.684-1.38 1.448 8.515 8.115 9.218 1.468.125.027a1.1 1.1 0 0 1 .789 1.262l-.86 4.631-.029.119a1.1 1.1 0 0 1-1.056.784H37.9a5.002 5.002 0 0 0-9.8 0H17v2h11.1a5.002 5.002 0 0 0 9.8 0h3.34l.186-.005a3.1 3.1 0 0 0 2.867-2.534l.86-4.628.032-.207a3.1 3.1 0 0 0-.548-2.151l-.127-.167a3.1 3.1 0 0 0-1.925-1.106zM33 35a3 3 0 1 1 0 6 3 3 0 0 1 0-6m-1.5 3a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m2 0a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0M25 36v-1h-4v1z",
    clipRule: "evenodd"
  })));
};

export { IconVehicleCharging, IconVehicleCharging as default };
